import React from 'react';
import AddItem, { Props as AddItemProps } from '@wix/da-ds/pkg/AddItem';
import s from './AddItemCard.scss';

export interface Props extends AddItemProps {
  hasCoreMembership?: boolean;
  height?: number;
  nonCoreMembershipView?: React.ReactNode;
}

export const AddItemCard: React.FC<Props> = ({
  hasCoreMembership,
  height,
  nonCoreMembershipView,
  ...props
}) => {
  if (nonCoreMembershipView && !hasCoreMembership) {
    return <div className={s['non-core-card']}>{nonCoreMembershipView}</div>;
  }

  return (
    <div className={s['root']} style={{ height }}>
      <AddItem className={s['add-item-card']} {...props} />
    </div>
  );
};
AddItemCard.displayName = 'AddItemCard';
export default AddItemCard;
